import DataGrid, { Column } from 'devextreme-react/data-grid';
import { DocumentReviewApi } from '@apply/api';

interface TranscriptReviewResultsParameters {
    responses: DocumentReviewApi.ITaxReviewResultForYear;
    handleDownload: (taxYears: string[]) => void;
}

export const TranscriptReviewResults: React.FC<TranscriptReviewResultsParameters> = ({ responses, handleDownload }) => {
    const styles = {
        formRow: { marginBottom: '0' },
        formColumn: { padding: '5px' },
        informationNote: { color: '#777' },
    };

    return (
        <>
            {!!Object.keys(responses).length && (
                <>
                    <h2 style={{ marginTop: '1.5rem' }}>Results</h2>
                    <div style={styles.informationNote}>
                        <p>
                            <em>Note:</em> &nbsp; Results are AI generated and should be reviewed for accuracy before making any
                            decisions.
                        </p>
                    </div>
                    <div
                        className='row'
                        style={{ paddingTop: '1.0rem' }}
                    >
                        <div
                            className='column small-12 large-6'
                            style={{ textAlign: 'center' }}
                        >
                            <button
                                type='button'
                                className='button hollow'
                                title='Download Excel - All'
                                onClick={() => handleDownload(Object.keys(responses))}
                                style={{ width: '100%' }}
                            >
                                Download Report - All Tax Years
                            </button>
                        </div>
                    </div>
                </>
            )}
            {Object.keys(responses).map((yearStr) => (
                <div key={yearStr}>
                    <div
                        className='row'
                        style={{ paddingTop: '1.0rem' }}
                    >
                        <div className='column small-12 large-6'>
                            <strong>{yearStr}</strong>
                        </div>
                        <div
                            className='column small-12 large-6'
                            style={{ textAlign: 'right' }}
                        >
                            <button
                                type='button'
                                className='button hollow'
                                title='Download Excel'
                                onClick={() => handleDownload([yearStr])}
                            >
                                Download Report
                            </button>
                        </div>
                    </div>
                    <div
                        className='row'
                        style={{
                            ...styles.formRow,
                            paddingBottom: '1.5rem',
                        }}
                    >
                        <div
                            className='columns small-12 large-12'
                            style={styles.formColumn}
                        >
                            <DataGrid
                                id={'resultsGrid'}
                                keyExpr='name'
                                dataSource={responses[yearStr].lineItems}
                                showBorders={true}
                                rowAlternationEnabled={true}
                                pagerVisible={true}
                                allowSorting={true}
                                loadPanelEnabled={false}
                                remoteOperations={false}
                                noDataText='No results were generated'
                            >
                                <Column
                                    dataField='name'
                                    caption='Field'
                                    alignment='left'
                                />
                                <Column
                                    dataField='category'
                                    caption='Category'
                                    width={175}
                                    alignment='left'
                                />
                                <Column
                                    dataField='match'
                                    caption='Match'
                                    width={100}
                                />
                                <Column
                                    dataField='returnAmount'
                                    caption='Return Amount'
                                    width={175}
                                />
                                <Column
                                    dataField='transcriptAmount'
                                    caption='Transcript Amount'
                                    width={175}
                                    alignment='left'
                                />
                                <Column
                                    dataField='difference'
                                    caption='Difference'
                                    width={125}
                                    alignment='left'
                                />
                            </DataGrid>
                        </div>
                    </div>
                </div>
            ))}
        </>
    );
};

export default TranscriptReviewResults;
